import { render } from "./FullscreenModal.vue?vue&type=template&id=c139182a"
import script from "./FullscreenModal.vue?vue&type=script&lang=js"
export * from "./FullscreenModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/FullscreenModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c139182a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c139182a', __exports__)) {
    api.reload('c139182a', __exports__)
  }
  
  module.hot.accept("./FullscreenModal.vue?vue&type=template&id=c139182a", () => {
    api.rerender('c139182a', render)
  })

}


export default __exports__